import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class ShipmentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
        };
        this.updateTimer = {};

        const { shipmentStore } = this.props.stores;
        shipmentStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { shipmentStore } = this.props.stores;
        const { totalAppend, limit } = shipmentStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = shipmentStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                shipmentStore.updateOffset(offset);
                await shipmentStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { shipmentStore } = this.props.stores;
        shipmentStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { shipmentStore } = this.props.stores;
        await shipmentStore.saveField(id, field, value);
    }

    render() {
        const { loading, previewServer } = this.state;
        const { shipmentStore } = this.props.stores;
        const { shipments, queryFilter, saved } = shipmentStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {shipmentStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for shipments...'
                                    onInput={e => shipmentStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => shipmentStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {shipmentStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => shipmentStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {shipmentStore.sort !== shipmentStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => shipmentStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('uniqueId', '-')}>
                                                uniqueId {util.getSortIcon('uniqueId', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('warehouseRef', '-')}>
                                                warehouseRef {util.getSortIcon('warehouseRef', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('customerno', '')}>
                                                customerno {util.getSortIcon('customerno', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('shipDate', '')}>
                                                shipDate {util.getSortIcon('shipDate', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('articleno', '')}>
                                                articleno {util.getSortIcon('articleno', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('serial', '')}>
                                                serial {util.getSortIcon('serial', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('orderno', '')}>
                                                orderno {util.getSortIcon('orderno', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('shipper', '')}>
                                                shipper {util.getSortIcon('shipper', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('shipperId', '')}>
                                                shipperId {util.getSortIcon('shipperId', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('weight', '')}>
                                                weight {util.getSortIcon('weight', shipmentStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => shipmentStore.toggleSort('createdDate', '')}>
                                                createdDate {util.getSortIcon('createdDate', shipmentStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shipments && shipments.map(shipment => (
                                        <tr class={`${style.tableline}`}>
                                            <td class='font-weight-light'>
                                                <a href={`/shipments/${shipment.uniqueId}/Basics`}>{shipment.uniqueId}</a>
                                            </td>
                                            <td class='font-weight-light'>
                                                <span class='text-muted'>{shipment.warehouseId}</span> {shipment.warehouseRef}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.customerno}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.shipDate}
                                            </td>
                                            <td class='font-weight-light'>
                                                <span class='text-muted'>{shipment.qty} x</span> {shipment.articleno}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.serial}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.orderno}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.shipper}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.shipperId}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.weight}
                                            </td>
                                            <td class='font-weight-light'>
                                                {shipment.createdDate}<br />
                                                <span class='text-muted'>{shipment.updatedDate}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default ShipmentList;




// WEBPACK FOOTER //
// ./components/shipments/list.js